export default __webpack_public_path__ + "static/media/img-0648-north-macedonia-premium-face.17fcf913.png";